import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const cardSchemeService = {
  getAllCardSchemes,
  addCardScheme,
  getCardScheme
};

function getAllCardSchemes() {
  return apiCall("GET", apiUrls.schemes.base);
}

function addCardScheme(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.schemes.base, request);
}

function getCardScheme(id) {
  return apiCall("GET", `${apiUrls.schemes.base}/${id}`);
}
